import * as redux from 'redux';
import thunk from 'redux-thunk';
import persistState from 'redux-localstorage';
import { composeWithDevTools } from 'redux-devtools-extension';

export default (combineReducers, initialState = {}) => {
  const composeEnhancers = composeWithDevTools({
    name: 'estimate builder',
  });

  const store = redux.createStore(
    combineReducers,
    initialState,
    composeEnhancers(
      redux.applyMiddleware(thunk),
      persistState('estimateBuilder'),
    ),
  );

  return store;
};
